import { MAX_TERRAIN_EXAGGERATION, MIN_TERRAIN_EXAGGERATION } from '../domain/terrain-height';
import { CompactRangeControl } from './CompactRangeControl';

interface TerrainHeightControlProperties {
  readonly enabled: boolean;
  readonly value: number;
  readonly onChange: (value: number) => void;
}

export function TerrainHeightControl({ enabled, value, onChange }: TerrainHeightControlProperties) {
  return <CompactRangeControl label="Terrain height" value={value} min={MIN_TERRAIN_EXAGGERATION}
    max={MAX_TERRAIN_EXAGGERATION} step={.01} unit="×" disabled={!enabled} valueText={`${value.toFixed(2)} times actual height`}
    help={enabled ? 'Visual height only' : 'Choose a terrain map style'} onChange={onChange} />;
}
